import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const SensoryMotorFunction = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Sensory Motor Function</InputLabel>
      <Select
        value={moduleValues?.['Sensory Motor Function'] ?? ''}
        label='Sensory Motor Function'
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Sensory Motor Function']: e.target.value,
          }))
        }
      >
        {['Normal', 'Reduced', 'Absent'].map((x) => (
          <MenuItem key={x} value={x}>
            {x}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
)

export default SensoryMotorFunction
